import { ItemSetProvider } from '@exam-management/common/item-set-provider';
import { APP_PERMISSIONS } from '@exam-management/permissions';
import { QContentCreateItemSetSubQuestionHeader } from '@exam-management/qcontent-creation';
import { useParams } from '@exam-management/router';
import { Box } from '@shared/components';
import { PermissionGuard } from '@shared/permissions';
import { Outlet } from 'react-router-dom';

export default function ItemSetCreateSubQuestionLayout() {
  const { questionId } = useParams(
    '/qbank-structures/:structureId/qcontents/item-set/:questionId/create',
  );

  return (
    <PermissionGuard requiredPermission={APP_PERMISSIONS.QBANK.QUESTION.CREATE}>
      <ItemSetProvider itemSetId={questionId}>
        <Box>
          <QContentCreateItemSetSubQuestionHeader />
          <Outlet />
        </Box>
      </ItemSetProvider>
    </PermissionGuard>
  );
}
